import { EVENTS_INFO_CONSTANTS } from "../constants/constants";
import {DATE_FORMAT_MMM_DD_YYYY} from "../constants/statistics.dateConstants";
import moment from "moment";
export const getEventDescription = (appId, location, description, title) => {
  return location?.area?.name + ", " + location?.floor?.name 
  // const areaName = location?.area?.name
  //   ? (location?.area?.name).toLowerCase()
  //   : "area";
  // return appId === "IntrusionDetection"
  //   ? `Person detected in the ${areaName}`
  //   : appId === "SlipAndFall"
  //   ? `Slip and fall detected in the ${areaName}`
  //   : appId === "PhoneDetection"
  //   ? `Phone detected in the ${areaName}`
  //   : description;
};
export const getEventLocationDescription = (appId, location, description, title) => {
  const areaName = location?.area?.name || 'Unknown Area';
  const floorName = location?.floor?.name || 'Unknown Floor';
  const siteName = location?.site?.name || 'Unknown Site';
  return `${areaName}, ${floorName}, Site: ${siteName}`;
};


export const incidentCreatedFromNow = (incident) =>{
  return moment(Date.now()).diff(moment(incident.createdAt), "hours");
}


/**
 * Checks evidence status for both single incidents and arrays
 * @param {Object|Array} incidents - Single incident object or array of incidents
 * @param {Object} timerRef - Ref object to store interval ID
 * @param {Function} onPoll - Callback function to call when polling is needed
 */
export const checkForEvidenceStatus = (incidents, timerRef, onPoll) => {
  const incidentArray = Array.isArray(incidents) ? incidents : [incidents];

  let evidenceStatusCount = 0;

  incidentArray.forEach((incident) => {
    if (incident?.evidenceStatus === 0) {
      evidenceStatusCount++;
    } else if (incident?.evidences?.length) {
      const videoEvidence = incident.evidences.find((evidence) => evidence.mediaType === "video");
      if (!videoEvidence) {
        evidenceStatusCount++;
      }
    }
  });

  // Clear interval if no pending evidence
  if (evidenceStatusCount === 0 ) {
    if(incidentCreatedFromNow(incidents) > 720){
      return;
    }
    clearInterval(timerRef.current);
    timerRef.current = null;
    return;
  }

  // Set up polling if there are pending evidence and no interval exists
  if (!timerRef.current && evidenceStatusCount > 0) {
    timerRef.current = setInterval(() => {
      onPoll();
    }, 5000);
  }
};

/**
 * Checks evidence status for both single incidents and arrays
 * @param {Object|Array} incidents - Single incident object or array of incidents
 * @param {Object} timerRef - Ref object to store interval ID
 * @param {Function} onPoll - Callback function to call when polling is needed
 */
export const checkForEvidenceStatusFromDashbaord = (incidents, timerRef, onPoll) => {
  const incidentArray = Array.isArray(incidents) ? incidents : [incidents];

  let evidenceStatusCount = 0;

  incidentArray.forEach((incident) => {
    if (incident?.evidences?.length) {
      const videoEvidence = incident.evidences.find((evidence) => evidence.mediaType === "video");
      if (!videoEvidence) {
        evidenceStatusCount++;
      }
    }
  });

  // // Clear interval if no pending evidence
  if (evidenceStatusCount === 0) {
    clearInterval(timerRef.current);
    timerRef.current = null;
    return;
  }

  if (!timerRef.current) {
    // Set up polling if there are pending evidence and no interval exists
    timerRef.current = setInterval(() => {
      onPoll();
    }, 15000);
  }
};


export const getNotificationBannerType = (incidentCreatedBefore, hasOnlyImage, noMedia, videoDownloadError, hasOnlyVideo, hasVideoAndImage) => {
    if(incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MONTH) {
      return "info";
    }
    else if(incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_DAY && incidentCreatedBefore <= EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MONTH){
      return "error";
    }
    else if(incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_HOUR && incidentCreatedBefore <= EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_DAY){
      return "info";
    }
    else if(incidentCreatedBefore <= EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MINUTE){
      return "info";
    }
    else{
     if (hasOnlyImage) {
      return "info";
    } else if (noMedia) {
      return "error";
    } else if (videoDownloadError && (hasOnlyVideo || hasVideoAndImage)) {
      return "error";
    } else {
      return "info";
    }
  }
}

export const getNotificationBannerTitle = (options) => {
  const { incidentCreatedBefore, hasOnlyImage, noMedia, videoDownloadError, hasOnlyVideo, hasVideoAndImage, incident } = options;
  const alertParameters = incident?.deploymentConfig?.[0]?.config?.["alert-parameters"];
  const isCaptureVideoEvidenceEnabled = alertParameters?.["ignore_video_evidence"]  == undefined ? false : alertParameters?.["ignore_video_evidence"];
    if(incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MONTH) {
      return EVENTS_INFO_CONSTANTS.EVENT_CREATED_MONTH_BACK(incident?.evidences?.length >0 ? moment(incident?.evidences[0]?.mediaAvailableTill).format(DATE_FORMAT_MMM_DD_YYYY) : moment(incident?.createdAt).add(30, 'days').format(DATE_FORMAT_MMM_DD_YYYY) );
    } 
    else if(incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_DAY && incidentCreatedBefore <= EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MONTH){
      if (hasOnlyImage) {
      return isCaptureVideoEvidenceEnabled ? EVENTS_INFO_CONSTANTS.EVENT_CAPTURE_VIDEO_EVIDENCE_OFF : EVENTS_INFO_CONSTANTS.EVENT_VIDEO_FAILED_TO_LOAD;
      }else{
      return EVENTS_INFO_CONSTANTS.EVENT_SNAPSHOT_AND_VIDEO_FAILED_TO_LOAD;
      }
    } 
    else if(incidentCreatedBefore > EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_HOUR && incidentCreatedBefore <= EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_DAY){
      return EVENTS_INFO_CONSTANTS.REQUEST_EVENT_EVIDENTS;
    } 
    else if(incidentCreatedBefore <= EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MINUTE){
      if (hasOnlyImage) {
      return isCaptureVideoEvidenceEnabled ? EVENTS_INFO_CONSTANTS.EVENT_CAPTURE_VIDEO_EVIDENCE_OFF :  EVENTS_INFO_CONSTANTS.EVENT_VIDEO_PROCESSING;
      } else if(noMedia){
        return isCaptureVideoEvidenceEnabled ? EVENTS_INFO_CONSTANTS.EVENT_IMAGE_PROCESSING : EVENTS_INFO_CONSTANTS.EVENT_IMAGE_AND_VIDEO_PROCESSING;
      } else {
        return isCaptureVideoEvidenceEnabled ? EVENTS_INFO_CONSTANTS.EVENT_IMAGE_PROCESSING : EVENTS_INFO_CONSTANTS.EVENT_IMAGE_AND_VIDEO_PROCESSING;
      }
    } 
    else {
      if (hasOnlyImage) {
        return isCaptureVideoEvidenceEnabled ? EVENTS_INFO_CONSTANTS.EVENT_CAPTURE_VIDEO_EVIDENCE_OFF:  EVENTS_INFO_CONSTANTS.EVENT_VIDEO_PROCESSING;
      } else if (noMedia) {
        return EVENTS_INFO_CONSTANTS.EVENT_SNAPSHOT_AND_VIDEO_FAILED_TO_LOAD;
      } else if (videoDownloadError && (hasOnlyVideo || hasVideoAndImage)) {
        return EVENTS_INFO_CONSTANTS.EVENT_VIDEO_FAILED_TO_LOAD;
      } else {
        return "";
      }
    }
}